export const QR_DATA = 'QR_DATA';
export const QR_DATA_SUCCESS = 'QR_DATA_SUCCESS';
export const QR_DATA_FAIL = 'QR_DATA_FAIL';

export const QR_DATA_LIST = 'QR_DATA_LIST';
export const QR_DATA_LIST_SUCCESS = 'QR_DATA_LIST_SUCCESS';
export const QR_DATA_LIST_FAIL = 'QR_DATA_LIST_FAIL';

export const QR_DATA_UPDATE_STORAGE = 'QR_DATA_UPDATE_STORAGE';

export const QR_DATA_CLEAR = 'QR_DATA_CLEAR';

export const DELETING_PIECE = 'DELETING_PIECE';
export const DELETING_PIECE_SUCCESS = 'DELETING_PIECE_SUCCESS';
export const DELETING_PIECE_FAIL = 'DELETING_PIECE_FAIL';
export const DELETING_PIECE_CLEAR = 'DELETING_PIECE_CLEAR';
